// extracted by mini-css-extract-plugin
export default {"cc-popbox-youtube":"cwcOnyTq","cc-content-new":"BJbFUwhG","cc-content-player":"GtDALqU0"};